import type React from "react";
import { useState } from "react";
import Button, { ButtonVariant } from "../Buttons/Button";
import { MdOutlineFileDownload } from "react-icons/md";
import axiosInstance from "../../api/axiosInstance";
import type { IconType } from "react-icons";
import { sendAnalyticsEvent } from "../../FirebaseConfig";
import { PDFDocument } from "pdf-lib";

const { REACT_APP_API_PATH } = process.env;

interface Props {
    fileName: string;
    label?: string;
    className?: string;
    icon?: IconType | null;
    iconSize?: number;
    module: string;
    source: string;
    variant?: ButtonVariant;

}

const DownloadPDFWithFetch: React.FC<Props> = ({
    fileName,
    label = "Descargar",
    className,
    icon = MdOutlineFileDownload,
    iconSize = 16,
    module,
    source,
    variant = 'primary'
}) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleDownload = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.get(
                `${REACT_APP_API_PATH}/indicadores/pdf?filename=${fileName}`
            );
            const bytes = Uint8Array.from(atob(response.data.data), (c) =>
                c.charCodeAt(0)
            );
            const pdfDoc = await PDFDocument.load(bytes);
            const pdfBytes: any = await pdfDoc.save();

            const url = URL.createObjectURL(
                new Blob([pdfBytes.buffer], { type: "application/pdf" })
            );

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${fileName}`);

            sendAnalyticsEvent("downloaded_report", {
                report_title: fileName.trim(),
                file_type: "pdf",
                source: source,
                module: module,
            });

            document.body.appendChild(link);
            link.click();

            URL.revokeObjectURL(url);
            document.body.removeChild(link);
        } catch (error) {
            console.error("Error al descargar el archivo PDF:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Button
            onClick={handleDownload}
            label={isLoading ? "Descargando..." : label}
            as="link"
            icon={icon ? icon : undefined}
            showIconLeft={true}
            showIconRight={false}
            className={className}
            disabled={isLoading}
            iconSize={iconSize}
            variant={variant}
        />
    );
};

export default DownloadPDFWithFetch;